export class EncryptionNotSupportedError extends Error {
  constructor(message) {
    super(message);
    this.name = 'EncryptionNotSupportedError';
  }
}
